export default {
  kz: {
    symbol: "₸",
    code: "kz",
    abbr: "KZT",
  },
  mn: {
    symbol: "₮",
    code: "mn",
    abbr: "MNT",
  },
  kg: {
    symbol: "KGS",
    code: "kg",
    abbr: "KGS",
  },
  ru: {
    symbol: "₽",
    code: "ru",
    abbr: "RUB",
  },
};
